import { render, staticRenderFns } from "./ModalEscolhaEnvolvidos.vue?vue&type=template&id=5b57ed7c&scoped=true"
import script from "./ModalEscolhaEnvolvidos.vue?vue&type=script&lang=js"
export * from "./ModalEscolhaEnvolvidos.vue?vue&type=script&lang=js"
import style0 from "./ModalEscolhaEnvolvidos.vue?vue&type=style&index=0&id=5b57ed7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b57ed7c",
  null
  
)

export default component.exports